import { render } from "./el-rep-photo.vue?vue&type=template&id=19631f12&scoped=true"
import script from "./el-rep-photo.vue?vue&type=script&lang=ts"
export * from "./el-rep-photo.vue?vue&type=script&lang=ts"

import "./el-rep-photo.vue?vue&type=style&index=0&id=19631f12&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-19631f12"

export default script